import _ from 'lodash';

import { CGMManufacturers } from './constants';

export const findManufacturerOption = (value) =>
  _.find(Object.values(CGMManufacturers), (option) => option.value === value);
